import React, { useEffect } from 'react';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import Panel from '../Panel';
import Header from '../Header';

import { AppWrapper } from './App.style';

const layout = [
  {i: 'a', x: 0, y: 0, w: 6, h: 12, minW: 2, minH: 3},
  {i: 'b', x: 6, y: 0, w: 6, h: 12, minW: 2, minH: 3},
  {i: 'c', x: 0, y: 0, w: 6, h: 12, minW: 2, minH: 3},
  {i: 'd', x: 6, y: 0, w: 6, h: 12, minW: 2, minH: 3},
];

function App({ pollCurrentData }) {
  // TODO: Make responsive
  // TODO: Store layout in redux and provide options to add/remove panels
  // Trigger a deploy (Can remove this line)
  useEffect(function() { pollCurrentData() }, [])
  
  return (
    <AppWrapper>
      <Panel id={1} />
    </AppWrapper>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.component.js